import { useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import { SealCheck, SealWarning } from "./svg/Seals";

export interface TourStep {
    title: string;
    body?: React.ReactNode;
    /** run when this step becomes active (e.g. fly the camera) */
    onEnter?: () => void;
    /** run when this step is left, via navigation or closing the pane */
    onLeave?: () => void;
}

interface HelpPaneProps {
    steps:   TourStep[];
    step:    number;                       // current index
    setStep: ( i: number ) => void;
    onClose: () => void;
}

export function AbandonedVehicleHelpPane( { steps, step, setStep, onClose }: HelpPaneProps ) {
    const last = step === steps.length - 1;

    // keep refs current so unmount cleanup sees the latest step
    const stepRef  = useRef( step );  stepRef.current  = step;
    const stepsRef = useRef( steps ); stepsRef.current = steps;

    // onEnter on mount, onLeave on unmount (covers X, Done, and any other unmount)
    useEffect( () => {
        stepsRef.current[stepRef.current]?.onEnter?.();
        return () => stepsRef.current[stepRef.current]?.onLeave?.();
    }, [] );

    const go = ( i: number ) => {
        if( i === step || i < 0 || i >= steps.length ) { return; }
        steps[step]?.onLeave?.();
        setStep( i );
        steps[i]?.onEnter?.();
    };

    const sealFor = ( i: number ) => {
        if( i <   step ) return <SealCheck   className="fs-3 text-success"   />;
        if( i === step ) return <SealWarning className="fs-3 text-info"      />;
        return                  <SealWarning className="fs-3 text-secondary" />;
    };

    return <div className="d-flex flex-column h-100 p-3 gap-3">
        <div className="d-flex align-items-center">
            <h5 className="flex-grow-1 m-0">Getting Started</h5>
            <Button variant="close" onClick={onClose} />
        </div>

        <div className="flex-grow-1 d-flex justify-content-center flex-column gap-1">
            {steps.map( ( s, i ) =>
                <div
                    key={i}
                    role="button"
                    onClick={() => go( i )}
                    className={`p-2 rounded ${i === step ? "bg-primary-subtle" : ""}`}>
                    <div className="d-flex align-items-center gap-2">
                        {sealFor( i )}
                        <div className={i === step ? "fw-semibold" : "text-secondary"}>
                            {s.title}
                        </div>
                    </div>
                    {/* {i === step && s.body && */}
                        <div className="small text-body-secondary pt-1">{s.body}</div>
                    {/* } */}
                </div>
            )}
        </div>

        <div className="d-flex gap-2">
            <Button
                variant="outline-secondary"
                className="flex-grow-1"
                disabled={step === 0}
                onClick={() => go( step - 1 )}>
                Back
            </Button>
            <Button
                variant="primary"
                className="flex-grow-1"
                onClick={() => last ? onClose() : go( step + 1 )}>
                {last ? "Done" : "Next"}
            </Button>
        </div>
    </div>;
}